(function () {
  if (window.__wudyMsV3Booted) return;
  window.__wudyMsV3Booted = true;

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function initHeroGallery(root) {
    if (!root) return;
    var main = root.querySelector('[data-msv3-hero-main]');
    var picks = root.querySelectorAll('[data-msv3-hero-pick]');
    if (!main || !picks.length) return;

    var section = root.closest('section') || root;
    var spotlightLink = section.querySelector('[data-msv3-spotlight-link]');
    var spotlightTitle = section.querySelector('[data-msv3-spotlight-title]');
    var spotlightPrice = section.querySelector('[data-msv3-spotlight-price]');
    var spotlightThumb = section.querySelector('[data-msv3-spotlight-thumb]');

    picks.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var img = btn.getAttribute('data-image');
        if (!img) return;

        main.style.opacity = '0';
        window.setTimeout(function () {
          main.src = img;
          main.alt = btn.getAttribute('data-title') || '';
          main.style.opacity = '1';
        }, prefersReducedMotion() ? 0 : 180);

        picks.forEach(function (b) {
          b.classList.remove('is-active');
          b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-pressed', 'true');

        if (spotlightLink) spotlightLink.href = btn.getAttribute('data-url') || spotlightLink.href;
        if (spotlightTitle) spotlightTitle.textContent = btn.getAttribute('data-title') || spotlightTitle.textContent;
        if (spotlightPrice) spotlightPrice.textContent = btn.getAttribute('data-price') || spotlightPrice.textContent;
        if (spotlightThumb && img) spotlightThumb.src = img.replace('width=1800', 'width=160');
      });
    });
  }

  function initTimelineScroll(root) {
    if (!root) return;
    var track = root.querySelector('[data-msv3-timeline-track]');
    if (!track) return;

    var steps = track.querySelectorAll('[data-msv3-timeline-step]');
    if (!steps.length || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-active');
          }
        });
      },
      { root: track, threshold: 0.55, rootMargin: '0px -20% 0px -20%' }
    );

    steps.forEach(function (step) {
      observer.observe(step);
    });
  }

  function boot(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-msv3-hero-gallery]').forEach(initHeroGallery);
    scope.querySelectorAll('[data-msv3-timeline]').forEach(initTimelineScroll);
  }

  document.addEventListener('DOMContentLoaded', function () {
    boot();
  });
  document.addEventListener('shopify:section:load', function (e) {
    boot(e.target);
  });
})();
